import { Component, OnInit } from '@angular/core';
import { EventService } from '../../services/event/event.service';

@Component({
  selector: 'app-link-upload-input-modal',
  templateUrl: './link-upload-input-modal.component.html',
  styleUrls: ['./link-upload-input-modal.component.css']
})
export class LinkUploadInputModalComponent implements OnInit {

  public link = null;

  constructor(
    public event: EventService
  ) { }

  ngOnInit() {
    this.event.on('link-upload-input-modal', 'setCourseLinkModalData', data => {
      this.link = data;
    });
  }

  onModalSubmitBtnClick() {
    this.event.emit('CourseLinkUploadInput.save', this.link);
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/link-upload-input-modal/link-upload-input-modal.component.ts